// ToastCleaner.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

export default function ToastCleaner() {
  const location = useLocation();

  useEffect(() => {
    toast.dismiss(); // route change hote hi purane toasts band kar do
  }, [location]);

  return null;
}
